import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, postApi } from 'services/_api';
import { CHANNEL, PATH_PROCON } from 'services/_path';

// TYPES
import { Types } from './types';

// ACTIONS
import {
	tiposDocumentosCompraSuccess,
	tiposDocumentosCompraFailure,
} from './actions';

function* tiposDocumentosCompraRequest() {
	const response: ApiResponse = yield call(
		postApi,
		PATH_PROCON,
		`dominios-crm/${CHANNEL}/tipos-documentos-compra`,
		{},
	);

	if (response.status === 200) {
		yield put(tiposDocumentosCompraSuccess(response));
	} else {
		yield put(tiposDocumentosCompraFailure(response));
	}
}

export default all([
	takeLatest(
		Types.TIPOS_DOCUMENTOS_COMPRA_REQUEST,
		tiposDocumentosCompraRequest,
	),
]);
